export interface TblMitglieder {
  id: number; // uint
  name: string; // string
  status: string; // string
  unternehmensnameZUSATZ: string; // string
  suchname2: string; // bool  
  zrNummer: string; // bool
  konditionen: string; // string
  strasse: string; // bool
  plz: string; // string
  ort: string; // string
  land: string; // string
  telefon: string; // string
  eMailAdresse: string; // string
  uStIdNrn: string; // string
  zrBeginn: string; // string
  zrEnde: string; // string
  plzGebiet	: string; // string
  plzGebietFull	: string; // string
  webseite: string; // string
  hBID: string; // string
  vMEZugehoerigkeit: string; // string
  count_records: number;
  mitgliederList: any;
}

export interface Value {
  value: TblMitglieder[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

// init api object
function toAPI(data: Partial<TblMitglieder>): any {
  return {
    id: data?.id || 0,
    name: data?.name || '',
    status: data?.status || '',
    unternehmensnameZUSATZ: data?.unternehmensnameZUSATZ || '',
    suchname2: data?.suchname2 || '',    
    zrNummer: data?.zrNummer || '',
    konditionen: data?.konditionen || '',
    strasse: data?.strasse || '',
    plz: data?.plz || '',
    ort: data?.ort || '',
    land: data?.land || '',
    telefon: data?.telefon || '',
    eMailAdresse: data?.eMailAdresse || '',
    uStIdNrn: data?.uStIdNrn || '',
    zrBeginn: data?.zrBeginn || '',
    zrEnde: data?.zrEnde || '',
    plzGebiet	: data?.plzGebiet	 || '',
    plzGebietFull	: data?.plzGebietFull	 || '',
    webseite: data?.webseite || '',
    hBID: data?.hBID || '',
    count_records: data?.count_records || 0, 
    vMEZugehoerigkeit: data?.vMEZugehoerigkeit || '',    
    mitgliederList: data?.mitgliederList || [],
  };
}

function parse(data?: Partial<TblMitglieder>): TblMitglieder {
  return {
    id: data?.id || 0,
    name: data?.name || '',
    status: data?.status || '',
    unternehmensnameZUSATZ: data?.unternehmensnameZUSATZ || '',
    suchname2: data?.suchname2 || '',    
    zrNummer: data?.zrNummer || '',
    konditionen: data?.konditionen || '',
    strasse: data?.strasse || '',
    plz: data?.plz || '',
    ort: data?.ort || '',
    land: data?.land || '',
    telefon: data?.telefon || '',
    eMailAdresse: data?.eMailAdresse || '',
    uStIdNrn: data?.uStIdNrn || '',
    zrBeginn: data?.zrBeginn || '',
    zrEnde: data?.zrEnde || '',
    plzGebiet	: data?.plzGebiet	 || '',
    plzGebietFull	: data?.plzGebietFull	 || '',
    webseite: data?.webseite || '',
    hBID: data?.hBID || '',
    vMEZugehoerigkeit: data?.vMEZugehoerigkeit || '',
    count_records: data?.count_records || 0, 
    mitgliederList: data?.mitgliederList || [],
  };
}

export default {
  parse,
  toAPI: toAPI,
};
